export class TechQuestionVo {
    id: any;
    category: any;
    domain: any;
    description: any;
    link: any;
    tags: string[]=[];
    yrsOfExp: any;
    isContact: any;
    contentDetails: any;
    createdDate:any;
    linkMetaData:any;
    userId:any;
    comments: Comment[] = [];
}

export class Comment {
    date: any;
    comment: any;
    usrName: any;
    questIcon: any;
}